import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Divider, Form, Header, Segment } from 'semantic-ui-react'
import FormEntry from '../../../models/FormEntry'
import Input from '../Inputs/Input'
import { Years, ExtinguisherCompanies, ExtinguisherTypes, ExtinguisherFormats, ExtincteurClass } from '../../../utils/FormSelectHelper'
import Select from '../Inputs/Select'
import SelectMultiple from '../Inputs/SelectMultiple'
import Checkbox from '../Inputs/Checkbox'

@observer
class RIEEXT000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    changeMenuType: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { changeMenuType } = this.props
    changeMenuType('search', {
      label: 'Rechercher équipement par no série ou localisation',
      enableShowAll: true,
      searchFields: [
        { fieldName: 'noSerie', isFixed: true },
        { fieldName: 'localisation', isFixed: true }
      ]
    })
  }

  render () {
    const { equipment } = this.props
    return (
      <Segment>
        <Form>
          <Form.Group>
            <Input width={1} name='numero' formEntry={equipment} label='Numéro' isFixed />
            <Input width={5} name='localisation' formEntry={equipment} label='Localisation' isFixed />
            <Input width={10} name='notes' formEntry={equipment} label='Notes' />
          </Form.Group>
          <Form.Group>
            <Checkbox name='verificationEffectue' formEntry={equipment} label='Vérification effectué' />
          </Form.Group>
          <Divider />

          <Form.Group widths='equal'>
            <Select options={ExtinguisherTypes()} defaultValue='abc' name='type' formEntry={equipment} label='Type' />
            <Select options={ExtinguisherCompanies()} defaultValue='ok' name='marque' formEntry={equipment} label='Marque' />
            <Input name='noSerie' formEntry={equipment} label='No. série' isFixed />
          </Form.Group>
          <Form.Group widths='equal'>
            <Select options={ExtincteurClass()} name='classe' formEntry={equipment} label='Classe' />
            <Select options={ExtinguisherFormats()} defaultValue='2.5' name='format' formEntry={equipment} label='Format' />
            <div className='field' />
          </Form.Group>
          <Form.Group />
          <Divider />
          <Form.Group widths='equal'>
            <Select options={Years()} name='dateFabrication' formEntry={equipment} label='Date fabrication' />
            <Select
              options={Years()} name='dernierEssai' formEntry={equipment} label='Dernier essai' onAfterChanged={(name, value) => {
                equipment.updateValue('prochainEssai', +value + 12)
              }}
            />
            <Input name='prochainEssai' formEntry={equipment} label='Prochain essai' isFixed />
          </Form.Group>
          <Form.Group widths='equal'>
            <Select
              options={Years()} name='derniereMaintenance' formEntry={equipment} label='Dernière maintenance' isFixed onAfterChanged={(name, value) => {
                equipment.updateValue('prochaineMaintenance', +value + 6)
              }}
            />
            <Input name='prochaineMaintenance' formEntry={equipment} label='Prochaine maintenance' isFixed />
            <div className='field' />
          </Form.Group>
          <Divider />
          <Header as='h3' content='Action' />
          <Form.Group widths='equal'>
            <SelectMultiple
              formEntry={equipment} options={[
                { value: 'action_test', text: 'Test' },
                { value: 'action_maintenance', text: 'Maintenance' },
                { value: 'action_lance', text: 'Lance' },
                { value: 'action_neuf', text: 'Neuf' },
                { value: 'action_desuet', text: 'Désuet' },
                { value: 'action_hauteur', text: 'Hauteur' },
                { value: 'action_vitre', text: 'Vitre' },
                { value: 'action_chaine', text: 'Chaine' },
                { value: 'action_marteau', text: 'Marteau' },
                { value: 'action_recharge', text: 'Recharge' },
                { value: 'action_remplacement', text: 'Remplacement' },
                { value: 'action_pictogramme', text: 'Pictogramme' },
                { value: 'action_crochet', text: 'Crochet' },
                { value: 'action_serrure', text: 'Serrure' },
                { value: 'action_couverture', text: 'Couverture' },
                { value: 'action_absent', text: 'Absent' },
                { value: 'action_difAccess', text: "Difficile d'accès" },
                { value: 'action_pasAccess', text: "Pas d'accès" }
              ]}
            />
          </Form.Group>

          <Divider />
          <Header as='h3' content='Recommandation' />
          <Form.Group widths='equal'>
            <SelectMultiple
              formEntry={equipment} options={[
                { value: 'recommandation_test', text: 'Test' },
                { value: 'recommandation_maintenance', text: 'Maintenance' },
                { value: 'recommandation_lance', text: 'Lance' },
                { value: 'recommandation_neuf', text: 'Neuf' },
                { value: 'recommandation_desuet', text: 'Désuet' },
                { value: 'recommandation_hauteur', text: 'Hauteur' },
                { value: 'recommandation_vitre', text: 'Vitre' },
                { value: 'recommandation_chaine', text: 'Chaine' },
                { value: 'recommandation_marteau', text: 'Marteau' },
                { value: 'recommandation_recharge', text: 'Recharge' },
                { value: 'recommandation_remplacement', text: 'Remplacement' },
                { value: 'recommandation_pictogramme', text: 'Pictogramme' },
                { value: 'recommandation_crochet', text: 'Crochet' },
                { value: 'recommandation_serrure', text: 'Serrure' },
                { value: 'recommandation_couverture', text: 'Couverture' }
              ]}
            />
          </Form.Group>
        </Form>
      </Segment>
    )
  }
}

export default RIEEXT000
